<template>
  <div>123</div>
</template>

<script>
export default {
  name: "后台项目Index",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
